import { render, staticRenderFns } from "./progressOfTheStatisticsList.vue?vue&type=template&id=a2ec6076&scoped=true"
import script from "./progressOfTheStatisticsList.vue?vue&type=script&lang=js"
export * from "./progressOfTheStatisticsList.vue?vue&type=script&lang=js"
import style0 from "./progressOfTheStatisticsList.vue?vue&type=style&index=0&id=a2ec6076&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ec6076",
  null
  
)

export default component.exports